import ImpDarkMapType from './DarkMapType'
import ImpBlueMapType from './BlueMapType'
import ImpDarkGrayMapType from './DarkGrayMapType'
import ImpShadesOfGrayMapType from './ShadesOfGrayMapType'
import ImpSimplyDarkMapType from './SimplyDarkMapType'
import ImpLightMapType from './LightMapType'

export let DarkMapType = ImpDarkMapType
export let BlueMapType = ImpBlueMapType
export let DarkGrayMapType = ImpDarkGrayMapType
export let ShadesOfGrayMapType = ImpShadesOfGrayMapType
export let SimplyDarkMapType = ImpSimplyDarkMapType
export let LightMapType = ImpLightMapType